<template>
  <v-content>
    <v-container>
      <Navbar/>
      <v-row
        align="center"
        justify="center"
      > 
          <v-col
              cols="sm "
          >
              <v-data-table
                  :headers="headers"
                  :items="products"
                  sort-by="name"
                  class="elevation-1"
                  :items-per-page="8"
              >
                  <template v-slot:top>
                  <v-toolbar flat>
                      <v-toolbar-title>Products / {{ trackedProductsLength }} tracked products of {{ allProductsLength }}</v-toolbar-title>
                      <v-divider
                      class="mx-4"
                      inset
                      vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialog" max-width="500px">
                      <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">New product</v-btn>
                      </template>
                      <v-card>
                          <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                          <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="asin" label="Product ASIN"></v-text-field>
                                </v-col>
                              </v-row>
                          </v-container>
                          </v-card-text>

                          <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>p
                          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                          </v-card-actions>
                      </v-card>
                      </v-dialog>
                  </v-toolbar>
                  </template>
                  
                  <template v-slot:item.images="{ item }" >
                    <div v-if="(item && item.images && item.images.length>0)">
                      <v-img
                        :src="item.images[0].url"
                        alt="No image :("
                        aspect-ratio="1"
                        max-width="70"
                        max-height="70"
                        transition="true"
                      ></v-img>
                    </div>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        @click="deleteItem(item)"
                    >
                        delete
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                  <p> No data :(</p>
                  </template>
                  <template v-slot:item.is_tracked="{ item }">
                    <v-checkbox v-model="item.is_tracked" @change="setTraking(item)" class="mx-2"></v-checkbox>
                  </template>
              </v-data-table>
          </v-col>
          
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
  // Components
  import Navbar from "../components/Navbar";

  export default {
    data: () => ({
        dialog: false,
        headers: [
            { text: 'Tracked', value: 'is_tracked' },
            { text: 'Product image', value: 'images' },
            // {
            //   text: 'Product ID',
            //   align: 'left',
            //   value: 'id',
            // },
            { text: 'Title', value: 'name' },
            { text: 'Country', value: 'marketplace.country' },
            /*{ 
              text: 'Currency',
              align: 'right',
              value: 'currency' 
            },*/
            /*{ text: 'Price', value: 'price' },
            { text: 'Qantity', value: 'qt' },*/
            { text: 'Actions', value: 'action', sortable: false },
        ],
        productLink:'',
        editedIndex: -1,
        asin: '',
        defaultItem: {
            id: '#',
            name: 'Name of the product',
            price: 0.00,
            qt: 0,
        },
    }),
    components:{
      'Navbar' : Navbar
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Product' : 'Edit Product'
      },
      products (){
        return this.$store.getters.getAllProducts;
      },
      trackedProductsLength (){
        return this.$store.getters.getTrackedProducts.length;
      },
      allProductsLength (){
        return this.$store.getters.getAllProducts.length;
      }
    },
    mounted(){
        try{
          this.$store.dispatch('GET_PRODUCTS')
        }catch(e){
          // Show message
          this.$root.$emit('createAlert',{type:'error',content:'Something gone wrong '});
        }
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    methods: {
      editItem (item) {
        this.editedIndex = this.products.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.products.indexOf(item)
        if( confirm('Are you sure you want to delete this item?') ){
          try{
            this.$store.dispatch('DELETE_PRODUCT', index);
          }catch(e){
            // Show message
            this.$root.$emit('createAlert',{type:'error',content:'Something gone wrong, please try again '});
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        window.console.log(this.asin);
        try{
          this.$store.dispatch( 'SAVE_PRODUCT', this.asin );
        }catch(e){
          // Show message
          this.$root.$emit('createAlert',{type:'error',content:'Something gone wrong, please try again '});
        }

        // Close Modal after save
        this.close()
      },
      setTraking (item){
        try{
          this.$store.dispatch( 'SET_TRACKED_PRODUCT', item.id );
        }catch(e){
          // Show message
          this.$root.$emit('createAlert',{type:'error',content:'Something gone wrong, please try again '});
        }
      }
    },
  }
</script>

<style scoped>
    .chart-div{
        width: 100%;
        height: 250px !important;
    }
</style>
